import { immutableRecords } from "../../types";

export default (item, disabledItems) => {
  if (disabledItems.includes(item.messageType)) {
    item.disabled = true;
  }
  return immutableRecords.MenuItemRecord(item);
};
